
import { Product } from "@/types/product";

export const ipaSFP1G20: Product = {
  id: "ipa-sfp-1g20",
  groupId: "avoip",
  name: "IPA-SFP-1G20",
  subtitle: "1Gbps Single-mode Fiber SFP Module for VPX-TC1-LT, VPX-TC1-PRO",
  description: "1Gbps Single-mode Fiber SFP Module for VPX-TC1-LT, VPX-TC1-PRO\n\nFor use with VPX series LT and PRO with an SFP slot.",
  features: [
    "1Gb data transmission",
    "20km maximum range",
    "Hot-swappable",
    "Low power consumption",
    "Compatible with all VPX devices"
  ],
  images: ["/lovable-uploads/b1b0362c-5fc2-4539-87a2-8ca8bf6a0c1f.png"],
  slug: "ipa-sfp-1g20",
  networkSpeed: "vpx-accessories"
};
